import { Component, OnInit } from '@angular/core';

@Component({
  template: require('./localidades.component.html')
})
export class LocalidadesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/localidades/localidades.component.ts
 **/